import { CAMPAIGN_KIND, CAMPAIGN_STATUS } from "./constants";

export const SURVEY_SEND_OPERATION = {
    SMS: "survey_send_sms",
    EMAIL: "survey_send_email",
    IN_APP: "survey_send_in_app",
};

const KIND_RULES = {
    [CAMPAIGN_KIND.SMS]: { operation: SURVEY_SEND_OPERATION.SMS, perRecipient: true },
    [CAMPAIGN_KIND.EMAIL]: { operation: SURVEY_SEND_OPERATION.EMAIL, perRecipient: true },
    [CAMPAIGN_KIND.USERS]: { operation: SURVEY_SEND_OPERATION.IN_APP, perRecipient: false },
    [CAMPAIGN_KIND.IN_APP]: { operation: SURVEY_SEND_OPERATION.IN_APP, perRecipient: false },
};

export const isSurveySendTariff = (code) =>
    Object.values(SURVEY_SEND_OPERATION).includes(code);

export const billableRecipientCount = (campaign) => {
    const total = Number(campaign?.recipients_count) || 0;
    if (campaign?.status === CAMPAIGN_STATUS.SENT) {
        return Math.max(0, total - (Number(campaign?.completed_count) || 0));
    }
    return Math.max(0, total - (Number(campaign?.sent_count) || 0));
};

export const campaignSendQuoteSpec = (campaign) => {
    const rule = KIND_RULES[campaign?.kind];
    if (!rule) return null;
    if (!rule.perRecipient) {
        return { operation: rule.operation, quantity: 1 };
    }
    const quantity = billableRecipientCount(campaign);
    if (quantity < 1) return null;
    return { operation: rule.operation, quantity };
};
